export enum KPIMessageTypes {
    CHANGE_ZONE         = 90,
    CHANGE_QUANTITY     = 100,
    CANCEL_TRUCKS       = 110
}
